import { Line, RightLine, Text, Wrapper } from './Divider.ui';

export const Divider = ({
  title,
  className,
}: {
  title: string;
  className?: string;
}) => (
  <Wrapper className={className}>
    <Line />
    <Text>{title}</Text>
    <RightLine />
  </Wrapper>
);
